import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Select from '../../UI/Select/Select';
import SecBTN from '../../UI/SecBTN';
import Input from '../../UI/Input/Input';
import { Link } from 'react-router-dom';
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';
import { isEmpty } from '../../utils/custom_funtions';
import { useNavigate } from 'react-router-dom';

const TopicWiseQuestionHtml = ({subjectList}) => {
  const [topicList,setTopicList] = useState([]);
  const [subtopicList,setSubTopicList] = useState([]);
  const [loader,setLoader] = useState(false);
  const [reqData, setReqData] = useState({
    subject:"",
    topic:"",
    subtopic:"",
    language:"",
    easy:"",
    medium:"",
    tough:"",
    tougher:"",
  })
   const navigate=useNavigate();

  const getTopicsBySid = (sid) => {
    setLoader(true)
    userService.getTopicListBySid(sid)
    .then(res => {
      setLoader(false)
      setTopicList(res.data.data)
    })
    .catch(err => {
      console.error(err)
      setLoader(false)
    })
  }
  const getSubTopicsBySid = (tid) => {
    setLoader(true)
    userService.getSubTopicByTid(tid)
    .then(res => {
      setLoader(false)
      setSubTopicList(res.data.data)
    })
    .catch(err => {
      console.error(err)
      setLoader(false)
    })
  }
  const onChangeHandler = (e) => {
    setReqData((prev) => {
      if(e.target.name === "subject"){
        prev['topic'] = '';
        prev['subtopic'] = '';
        getTopicsBySid(e.target.value)
      }
      if(e.target.name === "topic"){
        prev['subtopic'] = '';
        getSubTopicsBySid(e.target.value)
      }
      prev[e.target.name] = e.target.value;
      return { ...prev };
    });
  };

  

  const handleSubmit = () => {
    const payload = {
      subject: reqData.subject,
      topic: reqData.topic,
      subtopic: reqData.subtopic,
      language: reqData.language,
      easy: reqData.easy,
      medium: reqData.medium,
      tough: reqData.tough,
      tougher: reqData.tougher,
    };
  
    if (isEmpty(payload.subject) || isEmpty(payload.topic) || isEmpty(payload.language)) {
      alert("Please fill all required fields.");
      return;
    }
  
    setLoader(true);
    userService
      .TopicWiseHtml(payload)
      .then((res) => {
        setLoader(false);
        console.log("Response:", res.resdata);
        navigate('/topicwiseQuestionHtml', { state: { responseData: res.resdata,language:reqData.language } });
      
      })
      .catch((err) => {
        setLoader(false);
        console.error("Error:", err);
      });
  };
  


  return (
    <>
    {loader && <Loader />}
    <Row>
      <Col lg={3} md={4} sm={12} className="mb-3">
        {/* <h5 className='mb-3'>Upload Paper Request</h5> */}
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Select Subject:</Form.Label>
          <Select value={reqData.subject} name='subject' onChange={onChangeHandler}>
            <option value="" disabled>
              Select Subject
            </option>
            {subjectList.map(sub => {
              return <option key={sub.sub_name+sub.sub_id} value={sub.sub_id}>{sub.sub_name}</option>
            })
            }
          </Select>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Select Topics:</Form.Label>
          <Select name={"topic"} value={reqData.topic} onChange={onChangeHandler}>
            <option value="" disabled>
              {isEmpty(topicList.filter(x => x.status == 1)) ? "No Topic available" : "Select Topic"}
            </option>
            {topicList.filter(x => x.status == 1).map(topic => {
              return <option value={topic.topic_id}>{topic.topic_name}</option>
            })}
          </Select>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Select Sub-Topic:</Form.Label>
          <Select name="subtopic" value={reqData.subtopic} onChange={onChangeHandler} >
            <option value="" disabled>
              {isEmpty(subtopicList.filter(x => x.status == 1))? "No Subtopic available" :  "Select Sub-Topic"}
            </option>
            {subtopicList.filter(x => x.status == 1).map(subtopic =>{
              return <option value={subtopic.sub_topic_id}>{subtopic.Sub_topic_name}</option>
            })}
          </Select>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Select Language:</Form.Label>
          <Select name="language" value={reqData.language} onChange={onChangeHandler} >
            <option value="" disabled>
              Select Language
            </option>
            <option value='english'>English</option>
            <option value='hindi'>Hindi</option>
          </Select>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Easy:</Form.Label>
          <Input type="number" name='easy' value={reqData.easy} onChange={onChangeHandler} />
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Medium:</Form.Label>
          <Input type="number" name='medium' value={reqData.medium} onChange={onChangeHandler}/>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Tough:</Form.Label>
          <Input type="number" name='tough' value={reqData.tough} onChange={onChangeHandler}/>
        </Form.Group>
      </Col>
      <Col lg={3} md={4} sm={12} className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Tougher:</Form.Label>
          <Input type="number" name='tougher' value={reqData.tougher} onChange={onChangeHandler} />
        </Form.Group>
      </Col>
      <Col lg={12} md={12} sm={12}>
      <SecBTN className="sec-btn1" onClick={handleSubmit}>Show HTML</SecBTN>
      </Col>
    </Row>
    </>
  );
}

export default TopicWiseQuestionHtml